import { Dialog, DialogContent, DialogTitle, Paper, Box, DialogActions, Button } from "@mui/material";
import { ReceiptRequest } from "../../types/ReceiptRequest";

interface ReceiptRequestDialogProps {
  receiptRequest?: ReceiptRequest,
  onClose?: () => void,
};
export const ReceiptRequestDialog = (props: ReceiptRequestDialogProps) => {
  const { receiptRequest, onClose } = props;

  return (
    <Dialog open={receiptRequest !== undefined} onClose={onClose} sx={{ backdropFilter: 'blur(5px)' }} fullWidth>
      <DialogTitle>{receiptRequest?.name}</DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ position: 'relative', overflow: 'hidden' }}>
          <div style={{
            backgroundImage: `url(${receiptRequest?.file})`, 
            backgroundSize: 'cover',
            backgroundPosition: 'center center', 
            filter: 'blur(5px)',
            position: 'absolute',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
            zIndex: 0,
          }} />
          <div style={{ display: 'flex', flexDirection: 'row', position: 'relative', zIndex: 100, justifyContent: 'center' }}>
            <img src={receiptRequest?.file} style={{ height: 600 }} />
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
};